module.exports = __webpack_public_path__ + "static/media/instagram.75d8c2b7.svg";